var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2072 5.52419C13.0668 5.76231 11.845 5.90326 10.586 5.93678V9.41402H14.7073C14.6693 8.0444 14.4984 6.72765 14.2072 5.52419Z",
  fill: "#C6C6CE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.1202 9.414C4.15884 7.95219 4.34175 6.54144 4.65522 5.24657C3.62866 4.95841 2.68941 4.58587 1.87486 4.13812C0.759228 5.67759 0.109974 7.49476 0 9.414H4.1202Z",
  fill: "#C6C6CE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.1202 10.586H0C0.109974 12.5052 0.759228 14.3224 1.87483 15.8619C2.68937 15.4141 3.62866 15.0416 4.65522 14.7534C4.34175 13.4586 4.1588 12.0478 4.1202 10.586Z",
  fill: "#C6C6CE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6852 0.677248C11.3269 0.374127 10.959 0.169924 10.586 0.0651855V4.76463C11.7367 4.7326 12.85 4.60641 13.8877 4.39545C13.6973 3.81335 13.4759 3.26661 13.2248 2.76433C12.7735 1.86196 12.2555 1.15973 11.6852 0.677248Z",
  fill: "#C6C6CE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.97016 15.88C4.11229 16.1209 3.32391 16.4247 2.63137 16.7856C2.72435 16.8863 2.81905 16.9859 2.91656 17.0834C4.04314 18.21 5.39079 19.0351 6.8617 19.5184C6.44966 19.0314 6.0686 18.4432 5.72692 17.7598C5.43779 17.1816 5.18491 16.5512 4.97016 15.88Z",
  fill: "#C6C6CE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.77521 2.76433C6.52409 3.26661 6.30269 3.81335 6.11224 4.39545C7.15002 4.60641 8.26323 4.7326 9.41395 4.76463V0.0651855C9.04098 0.169963 8.67309 0.374127 8.31476 0.677248C7.74438 1.15973 7.22643 1.86196 6.77521 2.76433Z",
  fill: "#C6C6CE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8798 10.586C15.8412 12.0478 15.6582 13.4586 15.3448 14.7534C16.3713 15.0416 17.3106 15.4141 18.1252 15.8619C19.2408 14.3224 19.89 12.5053 20 10.586H15.8798Z",
  fill: "#C6C6CE"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0298 4.12003C15.8877 3.8791 16.676 3.57532 17.3685 3.21446C17.2755 3.1137 17.1809 3.01412 17.0833 2.91661C15.9568 1.79007 14.6091 0.965017 13.1382 0.48168C13.5502 0.968689 13.9313 1.55684 14.273 2.24016C14.5621 2.81843 14.815 3.44882 15.0298 4.12003Z",
  fill: "#C6C6CE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2247 17.2357C13.4759 16.7334 13.6972 16.1866 13.8877 15.6045C12.8499 15.3936 11.7367 15.2674 10.586 15.2353V19.9348C10.959 19.8301 11.3269 19.6259 11.6852 19.3227C12.2556 18.8403 12.7735 18.1381 13.2247 17.2357Z",
  fill: "#C6C6CE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3448 5.2466C15.6582 6.54148 15.8412 7.95222 15.8798 9.41403H20C19.89 7.49479 19.2408 5.67763 18.1252 4.13819C17.3106 4.5859 16.3713 4.95844 15.3448 5.2466Z",
  fill: "#C6C6CE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M10.586 10.586V14.0632C11.845 14.0968 13.0667 14.2377 14.2072 14.4758C14.4984 13.2723 14.6693 11.9556 14.7073 10.586H10.586Z",
  fill: "#C6C6CE"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M9.414 9.41402V5.93678C8.15499 5.90326 6.93324 5.76231 5.7928 5.52419C5.50156 6.72769 5.33068 8.0444 5.2927 9.41402H9.414Z",
  fill: "#C6C6CE"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M4.97016 4.12003C5.18487 3.44878 5.43779 2.81843 5.72692 2.24016C6.0686 1.55684 6.44966 0.96865 6.8617 0.48168C5.39083 0.965017 4.04314 1.79007 2.91656 2.91665C2.81905 3.01416 2.72435 3.11374 2.63137 3.2145C3.32391 3.57532 4.11229 3.8791 4.97016 4.12003Z",
  fill: "#C6C6CE"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0298 15.88C14.8151 16.5512 14.5621 17.1816 14.273 17.7598C13.9313 18.4432 13.5503 19.0314 13.1382 19.5184C14.6091 19.0351 15.9568 18.21 17.0834 17.0834C17.1809 16.9859 17.2756 16.8864 17.3686 16.7856C16.676 16.4247 15.8876 16.1209 15.0298 15.88Z",
  fill: "#C6C6CE"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M9.414 10.586H5.2927C5.33068 11.9556 5.50156 13.2724 5.7928 14.4758C6.93321 14.2377 8.15499 14.0968 9.414 14.0632V10.586Z",
  fill: "#C6C6CE"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M8.31476 19.3228C8.67309 19.6259 9.04102 19.8301 9.41395 19.9349V15.2354C8.26323 15.2675 7.15002 15.3937 6.11224 15.6046C6.30269 16.1867 6.52405 16.7335 6.77521 17.2358C7.22643 18.1381 7.74438 18.8403 8.31476 19.3228Z",
  fill: "#C6C6CE"
});

function SvgSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.8ab3c10e.svg";
export { ForwardRef as ReactComponent };